import { useState } from 'react';
import { Container } from '@mui/material';
import { IUser, useDocumentTitle } from '../common';
import { TeamTabs } from '.';

export const Admin = ({ user }: { user: IUser }) => {
  useDocumentTitle({ title: 'Registration Authorities' });

  const [currentTab, setCurrentTab] = useState(0);

  return (
    <Container maxWidth="xl" style={{ padding: 0 }}>
      <TeamTabs
        user={user}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
      />
    </Container>
  );
};
